import { useHistory } from 'react-router-dom';
import { CommonButton } from '../../../../../components/button/main';
import { CommonCard } from '../../../../../components/card';
import getFormatMessage from '../../../../../locales/get-format-message';
import { GetformatMoney } from '../../billing-overview/component/fomat-money';
import { goInvoicePage } from '../lib';
import styles from './index.module.scss';

export const MoneyCard = (props: { readonly money: number }) => {
  const { money } = props;
  const history = useHistory();
  return (
    <CommonCard
      title={getFormatMessage('can_open_amount')}
      className={styles.moneyCard}
      extra={
        <CommonButton
          onClick={() => {
            goInvoicePage(history, 'history');
          }}
        >
          {getFormatMessage('invoice_history')}
        </CommonButton>
      }
    >
      <GetformatMoney className={styles.money} money={money} />
    </CommonCard>
  );
};
